module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_section"
  }, [_vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("1.")]), _vm._v(" The Helder")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("2.")]), _vm._v(" The landing at Callantsoog")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("3.")]), _vm._v(" The Battle of Krabbendam, showing the Franco-Batavian attack and the British position on the Zype Canal")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("4.")]), _vm._v(" The Battle of Bergen")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("5.")]), _vm._v(" The Battle of Egmond")]), _vm._v(" "), _c('p', {
    staticClass: "illust"
  }, [_c('span', {
    staticClass: "illus"
  }, [_vm._v("6.")]), _vm._v(" The Battle of Castricum")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff68267a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Maps.vue
// module id = 69
// module chunks = 0